"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_js_1 = require("@tangibleplay/http-js");
var urls_1 = require("../../config/urls");
var websites_1 = require("../../../config/websites");
var normalizer_1 = __importDefault(require("./normalizer"));
var compute = function (_a) {
    var raw = _a.raw, environment = _a.environment, _b = _a.website, website = _b === void 0 ? websites_1.WebsiteValues.playosmo : _b, payloadData = _a.data, quantities = _a.quantities;
    return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_1;
        var _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0:
                    payload = {
                        website: website,
                        cart: payloadData.cart,
                        dynamic_price_skus: (_c = Object.entries(payloadData.dynamicPriceSkus)) === null || _c === void 0 ? void 0 : _c.reduce(function (acc, _a) {
                            var _b;
                            var key = _a[0], details = _a[1];
                            return __assign(__assign({}, acc), (_b = {}, _b[key] = {
                                price_paid: details.pricePaid,
                                item_price: details.itemPrice,
                                quantity: details.quantity,
                                discount: details.discount,
                            }, _b));
                        }, {}),
                        coupon_code: payloadData.couponCode,
                        referral: payloadData.referralCode,
                        shipping_method: payloadData.shippingMethod,
                        shipping_address: {
                            first_name: (_d = payloadData === null || payloadData === void 0 ? void 0 : payloadData.shippingAddress) === null || _d === void 0 ? void 0 : _d.firstName,
                            last_name: (_e = payloadData === null || payloadData === void 0 ? void 0 : payloadData.shippingAddress) === null || _e === void 0 ? void 0 : _e.lastName,
                            address_1: (_f = payloadData === null || payloadData === void 0 ? void 0 : payloadData.shippingAddress) === null || _f === void 0 ? void 0 : _f.address1,
                            address_2: (_g = payloadData === null || payloadData === void 0 ? void 0 : payloadData.shippingAddress) === null || _g === void 0 ? void 0 : _g.address2,
                            region: (_h = payloadData === null || payloadData === void 0 ? void 0 : payloadData.shippingAddress) === null || _h === void 0 ? void 0 : _h.state,
                            city: (_j = payloadData === null || payloadData === void 0 ? void 0 : payloadData.shippingAddress) === null || _j === void 0 ? void 0 : _j.city,
                            zip: (_k = payloadData === null || payloadData === void 0 ? void 0 : payloadData.shippingAddress) === null || _k === void 0 ? void 0 : _k.zip,
                            country: (_l = payloadData === null || payloadData === void 0 ? void 0 : payloadData.shippingAddress) === null || _l === void 0 ? void 0 : _l.country,
                        },
                        email: payloadData.email,
                        unique: payloadData.unique,
                        dev_time: payloadData.devTime,
                    };
                    _m.label = 1;
                case 1:
                    _m.trys.push([1, 3, , 4]);
                    return [4, (0, http_js_1.fetch)({
                            apiUrl: (0, urls_1.getPlayOsmoAPIUrl)(environment),
                            endpoint: '/api/v3/cart/compute',
                            body: payload,
                            method: 'POST',
                        })];
                case 2:
                    response = _m.sent();
                    return [3, 4];
                case 3:
                    error_1 = _m.sent();
                    throw error_1;
                case 4: return [2, raw
                        ? response.data
                        : (0, normalizer_1.default)(response.data, quantities, payload, response.status)];
            }
        });
    });
};
exports.default = compute;
